module.exports = __webpack_public_path__ + "static/media/naturalPerson.16d2acc2.svg";